<template>
   <div class="timeline">

      <div v-if="hasItems" class="wrapper-timeline">

         <div v-for="(timelineContent, timelineIndex) in dataTimeline"
            :key="timelineIndex"
            :class="wrapperItemClass(timelineIndex)">

            <div class="section-year">
               <p v-if="hasYear(timelineContent)" class="year">
                  {{ getYear(timelineContent.date_created) }}
               </p>
            </div>

            <TimelineItem
               :item-timeline="timelineContent"
               :date-locale="dateLocale"
               :color-dots="colorDots">
               <template #activity>
                  <div>
                     <slot name="activity" :data="timelineContent"></slot>
                  </div>
               </template>
            </TimelineItem>

            <slot name="section-button" :data="timelineContent"></slot>

         </div>
      </div>

      <p v-else>{{ messageWhenNoItems }}</p>

   </div>
</template>

<script>
import moment from 'moment'
import TimelineItem from './TimelineItem.vue'

export default {
  name: 'Timeline',
  components: {
    TimelineItem
  },
  props: {
    timelineItems: {
      type: Array,
      default: () => []
    },
    messageWhenNoItems: {
      type: String,
      default: ''
    },
    colorDots: {
      type: String,
      default: '#435666'
    },
    uniqueTimeline: {
      type: Boolean,
      default: false
    },
    uniqueYear: {
      type: Boolean,
      default: false
    },
    order: {
      type: String,
      default: ''
    },
    dateLocale: {
      type: String,
      default: ''
    }
  },

  computed: {
    hasItems() {
      return !!this.timelineItems.length
    },
    dataTimeline() {
      if (this.order === 'desc')
        return this.orderItems(this.timelineItems, 'desc')
      if (this.order === 'asc')
        return this.orderItems(this.timelineItems, 'asc')

      return this.timelineItems
    }
  },
  
  methods: {
    wrapperItemClass(timelineIndex) {
      const isSameYearPreviousAndCurrent = this.checkYearTimelineItem(
        timelineIndex
      )
      const isUniqueYear =
        this.uniqueYear &&
        isSameYearPreviousAndCurrent &&
        this.order !== undefined
      return {
        'wrapper-item': true,
        'unique-timeline': this.uniqueTimeline || isUniqueYear
      }
    },
    checkYearTimelineItem(timelineIndex) {
      const previousItem = this.dataTimeline[timelineIndex - 1]
      const nextItem = this.dataTimeline[timelineIndex + 1]
      const currentItem = this.dataTimeline[timelineIndex]
      if (!previousItem || !nextItem) {
        return false
      }
      const fullPreviousYear = this.getYear(previousItem)
      const fullNextYear = this.getYear(nextItem)
      const fullCurrentYear = this.getYear(currentItem)
      return (
        (fullPreviousYear === fullCurrentYear &&
          fullCurrentYear === fullNextYear) ||
        fullCurrentYear === fullNextYear
      )
    },
    getYear(date) {
      return moment(new Date(date)).format('YYYY')
    },
    hasYear(dataTimeline) {
      return (
         // dataTimeline.hasOwnProperty()
         // Object.prototype.hasOwnProperty.call(dataTimeline, 'from') && dataTimeline.from !== undefined
         dataTimeline.date_created != null
      )
    },
    getTimelineItemsAssembled(items) {
      const itemsGroupByYear = []
      items.forEach(item => {
        const fullTime = item.from.getTime()
        if (itemsGroupByYear[fullTime]) {
          return itemsGroupByYear[fullTime].push(item)
        }
        itemsGroupByYear[fullTime] = [item]
      })
      return itemsGroupByYear
    },
    orderItems(items, typeOrder) {
      const itemsGrouped = this.getTimelineItemsAssembled(items)
      const keysItemsGrouped = Object.keys(itemsGrouped)
      const timeItemsOrdered = keysItemsGrouped.sort((a, b) => {
        if (typeOrder === 'desc') {
          return b - a
        }
        return a - b
      })
      const mappedItems = timeItemsOrdered.map(
        timeItem => itemsGrouped[timeItem]
      )
      return [].concat.apply([], mappedItems)
    }
  }
}
</script>

<style lang="scss" scoped>
.timeline {
   text-align: left;
   width: 100%;
   // width: fit-content;
   max-width: 500px;

   .wrapper-timeline {
      position: relative;
   }

   .wrapper-item {
      display: grid;
      grid-template-columns: 90px 1fr 50px;
      //  margin-bottom: 20px;

      .section-year {
         display: flex;
         flex-direction: column;
         justify-content: center;
         align-items: center;
         margin-top: 0.8rem;
         border-radius: 5px;
         background: #435666;
         width: 68px;
         height: 36px;

         .year {
            margin: 0;
            color: #FFF;
            font-size: 14px;
            font-weight: 900;
         }
      }

      :slotted(.section-button) {
         display: flex;
         flex-direction: column;
         justify-content: center;
         align-items: center;
      }

      &.unique-timeline {
         margin-bottom: 0;
      }
   }
}
</style>